export default __webpack_public_path__ + "static/media/1936.718bdb8b.png";